import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const Container = styled.section`
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.6;
  margin-bottom: ${o => o.theme.spacing(6)};
  text-align: center;
  text-transform: uppercase;
  ${fromMd} {
    margin-bottom: ${o => o.theme.spacing(5)};
    margin-top: ${o => o.theme.spacing(5)};
  }
  > * + * {
    margin-inline-start: 40px;
  }
`

export const SelectedGender = styled.div`
  display: inline-block;

  &::after {
    background: black;
    content: '';
    display: block;
    height: 2px;
    position: relative;
    top: 3px;
  }
`
